module.exports = __webpack_public_path__ + "img/pic-logo-ol.c579024f.png";